export default {
  'Cases types': 'SANDIK TÜRLERİ',
  'Possible contents of the case': 'Sandığın olası içeriği',
  'Other cases': 'DİĞER SANDIKLAR',
  'Open for': 'Şunun karşılığında aç:',
};
